<template>
    <div class="container">

        <div class="panel panel-head hard-border">
            <div class="project-information">
                <h5>
                    <span v-text="user.name"></span>
                    <div class="number">Profile</div>
                </h5>
            </div>
            <div class="btn-actions">
                <a href="/users" class="btn btn-default" v-if="authorize('admin') && notAuthUser">
                    <i class="fa fa-users"></i> Users Page
                </a>
            </div>
        </div>

        <div class="alert alert-info d-flex justify-content-between align-items-center">
            <div class="w-75">
                Your profile information is pulled from your NLCAA ATT/ATE application, we try to keep the information up to date.
                To make any change to your information you must visit the
                <a class="font-weight-bold" target="_blank" href="https://nlcaa.org">nlcaa.org</a> website and pull the latest changes.
            </div>
           <div class="w-25 text-center">
               <button type="button" class=" btn btn-danger btn-sm" :disabled="form.isSubmitted" @click="save()">
                   <i class="fa fa-sync"></i> Pull Information
               </button>
           </div>
        </div>

        <div class="card panel panel-form">

            <div class="row">
                <div class="col-md-6">
                    <div class="bg-white border">
                        <table class="table table-hover mb-0">
                            <tbody>
                            <tr>
                                <td>Phone</td>
                                <td v-text="form.phone"></td>

                            </tr>
                            <tr>
                                <td>Company</td>
                                <td v-text="form.company"></td>

                            </tr>
                            <tr>
                                <td>Company Position</td>
                                <td v-text="form.company_position"></td>

                            </tr>
                            <tr>
                                <td>CSLB License</td>
                                <td v-text="form.cslb_license"></td>

                            </tr>
                            <tr>
                                <td>bio</td>
                                <td v-text="form.bio"></td>

                            </tr>
                            <tr>
                                <td>Address</td>
                                <td v-text="form.address"></td>

                            </tr>
                            <tr>
                                <td>City</td>
                                <td v-text="form.city"></td>

                            </tr>
                            <tr>
                                <td>Zip</td>
                                <td v-text="form.zip"></td>

                            </tr>
                            <tr>
                                <td>State</td>
                                <td v-text="form.county.state.name"></td>

                            </tr>
                            <tr>
                                <td>County</td>
                                <td v-text="form.county.name"></td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-6">
                    <div id="map" style="width: 100%; height: 400px; border: 1px solid #ccc; border-radius:4px"></div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>

    let Roles = require('@/mixins/Management/Roles')
    let CreateMap = require('@/mixins/CreateMap')
    let AutoCompleteAddress = require('@/mixins/AutoCompleteAddress')

    export default {

        mixins: [Roles, CreateMap, AutoCompleteAddress],

        props: {
            user: {
                type: Object,
                required: true,
            },
            counties: {
                type: Array,
                required: true,
            },
            returnUrl: {
                type: String,
                required: false,
            },
        },

        data(){
            return {
                form: new Form(this.user.profile, false),
            }
        },

        mounted() {
            App.bus.$on('google-maps-ready', () => {
                    this.initAddress(this.user.profile.full_address)
            })
        },

        methods: {

            save() {
                this.form.put(`/profile/${this.user.slug}`).then(response => {
                    Alert.withAction('The profile is in the process of being update, this process can take some minutes.').then(() => {
                        if (this.returnUrl) {
                            this.redirectTo(this.returnUrl)
                        } else {
                            this.refreshPage()
                        }
                    })
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            },

            setAddressFromPlace(place) {

                for (var key in this.addressParts) {
                    this.form[this.addressParts[key].to] = '';
                }

                for (var i = 0; i < place.address_components.length; i++) {

                    var addressType = place.address_components[i].types[0];

                    if (this.addressParts[addressType]) {
                        var val = (this.addressParts[addressType].join + place.address_components[i][this.addressParts[addressType].key]);
                        this.form[this.addressParts[addressType].to] += val;
                    }
                }

                var state = this.form.state_id;
                var county = this.form.county_id;

                App.bus.$emit('change-state-and-county', {
                    state: state,
                    county: county,
                })
            }
        },

        computed:{
            notAuthUser(){
                return this.user.id != App.config.userId;
            }
        }
    }
</script>
